import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useContext } from 'react';
import UserPurchaseContext from '~/context/home/UserPurchaseContext';
import ErrorBoundary from '~/utilities/ErrorBoundary';
import getStatusCardType from '~/utilities/home/getStatusCardType';
import OrderStatusCard from './OrderStatusCard';

const EmptyFallback = () => null;

export default function OrderStatusCardMapper() {
  const { trackEvent } = useContext(AnalyticsContext);
  const {
    userPurchase: {
      hasError,
      data: { orderState, vehicle, openVerifications }
    }
  } = useContext(UserPurchaseContext);
  if (hasError) {
    trackEvent('Order Status Card Load Failed');

    return null;
  }

  const cardType = getStatusCardType(orderState);

  if (cardType === null) return null;

  return (
    <ErrorBoundary
      FallbackComponent={EmptyFallback}
      key={cardType}
      section={`Home OrderStatusCard - ${cardType}`}
    >
      <OrderStatusCard
        cardStatus={cardType}
        openVerifications={openVerifications}
        orderState={orderState}
        vehicle={vehicle}
      />
    </ErrorBoundary>
  );
}
